import {Alert, Button, Card, Loader, Stack, Title} from '@mantine/core'
import {createFileRoute, useNavigate} from '@tanstack/react-router'
import {useEffect, useState} from 'react'

import {apiFetch} from '../api/client'
import {UnauthorizedError} from '../api/errors'
import {setStoredUser, type StoredUser} from '../lib/auth'

export const Route = createFileRoute('/verify')({
    validateSearch: (search: Record<string, unknown>) => ({
        token: (search['token'] as string) || '',
    }),
    component: VerifyPage,
})

function VerifyPage() {
    const {token} = Route.useSearch()
    const navigate = useNavigate()
    const [error, setError] = useState<string | null>(null)
    const [verifying, setVerifying] = useState(true)

    useEffect(() => {
        if (!token) {
            setError('No token provided.')
            setVerifying(false)
            return
        }

        async function verifyToken() {
            try {
                const user = await apiFetch<StoredUser>('/auth/verify', {
                    method: 'POST',
                    body: JSON.stringify({token}),
                })
                setStoredUser(user)
                navigate({to: '/'})
            } catch (err) {
                if (err instanceof UnauthorizedError) {
                    setError('This link is expired or invalid.')
                } else {
                    setError('Something went wrong. Please try again.')
                }
            } finally {
                setVerifying(false)
            }
        }

        verifyToken()
    }, [token, navigate])

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                background: '#f0f2f5',
            }}
        >
            <Card w={400} style={{overflow: 'visible'}}>
                <Card.Section withBorder inheritPadding py="md">
                    <Title order={3}>AdvanceWell Analytics</Title>
                </Card.Section>
                <Card.Section inheritPadding>
                    {verifying ? (
                        <Stack align="center" gap="md" py="xl">
                            <Loader size="lg" />
                            <div>Verifying link...</div>
                        </Stack>
                    ) : error ? (
                        <Stack>
                            <Alert title="Error" color="red" variant="light">
                                {error}
                            </Alert>
                            <Button fullWidth size="md" onClick={() => navigate({to: '/login'})}>
                                Back to Login
                            </Button>
                        </Stack>
                    ) : null}
                </Card.Section>
            </Card>
        </div>
    )
}
